import { Grid, Typography } from "@mui/material";
import { DateRangeFilterDropdown } from "Components/Shared/Filters/DateRangeFilterDropdown";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  dateFrom?: Date;
  dateTo?: Date;
  onDateFromChange: (date: Date | undefined) => void;
  onDateToChange: (date: Date | undefined) => void;
};

export const DateRangeFilter = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}: Props) => {
  const { t } = useResource();

  return (
    <Grid size={12}>
      <Typography fontSize={13} fontWeight={400} mb={1}>
        {t(RESOURCES.DateRange)}
      </Typography>
      <DateRangeFilterDropdown
        dateFrom={dateFrom}
        dateTo={dateTo}
        onDateFromChange={onDateFromChange}
        onDateToChange={onDateToChange}
      />
    </Grid>
  );
};
